/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import PageTabs from '@/components/shared/PageTabs';
import { useTranslator } from '@/hooks/useTranslator';

export const Route = createFileRoute('/(client)/inventory/(pages)/(list)')({
  component: InventoryListLayout,
});

function InventoryListLayout() {
  const { getTranslation: t } = useTranslator({ page: 'inventory' });

  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-hidden'>
      <PageTabs
        tabs={[
          {
            key: 'products',
            label: t('tabs.products'),
            to: '/inventory/products',
          },
          {
            key: 'components',
            label: t('tabs.components'),
            to: '/inventory/components',
          },
        ]}
        mode='path'
        moreLabel={t('tabs.more')}
      />
      <PageContainer>
        <Outlet />
      </PageContainer>
    </div>
  );
}
